import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cashConverter } from "../../../utils";

function WaterSupplyView({ onClose, open, prodd }) {
  const navigate = useNavigate();

  const items1 = [
    {
      key: "1",
      label: "Name",
      children: prodd?.waterName ?? "N/A",
    },
    
    {
      key: "2",
      label: "Treatment Type",
      children: prodd?.waterWaterSource ?? "N/A",
    },
    {
      key: "3",
      label: "Capacity",
      children: prodd?.waterVolume ?? "N/A",
    },
    {
      key: "4",
      label: "Pipeline Distance",
      children: prodd?.waterPipelineDistance ?? "N/A",
    },
    {
      key: "5",
      label: "Acreage",
      children: prodd?.waterAcreage ?? "N/A",
    },
    {
      key: "6",
      label: "Start Date",
      children: (
        <div>
          {prodd?.waterStartDate
            ? moment(prodd?.waterStartDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "7",
      label: "End Date",
      children: (
        <div>
          {prodd?.waterEndDate
            ? moment(prodd?.waterEndDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "8",
      label: "Budget/Cost",
      children: prodd?.waterTimeFrame ?? "N/A",
    },
   
    {
      key: "9",
      label: "Remarks",
      children: prodd?.waterRemarks ?? "N/A",
    },
    {
      key: "10",
      label: "Water Loss",
      children: prodd?.waterLoss ?? "N/A",
    },
    {
      key: "11",
      label: "Metered",
      children: prodd?.waterMetered ?? "N/A",
    },
    {
      key: "13",
      label: "Pressure System",
      children: prodd?.waterPressureSystem ?? "N/A",
    }, 
    {
      key: "14",
      label: "Implementing Agency",
      children: prodd?.waterAgency ?? "N/A",
    }, 
    {
      key: "15",
      label: "Managing Entity",
      children: prodd?.waterManagingAgency ?? "N/A",
    },  
  ];
  const items2 = [
    {
      key: "5",
      label: "County",
      children: prodd?.countyCode ?? "N/A",
    },
    {
      key: "1",
      label: "SubCounty",
      children: prodd?.subCountyCode ?? "N/A",
    },
    {
      key: "2",
      label: "Location",
      children: prodd?.locLocation ?? "N/A",
    },
    {
      key: "3",
      label: "SubLocation",
      children: prodd?.slocLocation ?? "N/A",
    },
    {
      key: "45",
      label: "Constituency",
      children: prodd?.constName ?? "N/A",
    },
    {
      key: "4",
      label: "Ward",
      children: prodd?.wdWard ?? "N/A",
    }, 
    {
      key: "2",
      label: "Cost",
      children: <div>{cashConverter(prodd?.waterCost)}</div>,
    },
    
    {
      key: "8",
      label: "Funding Source",
      children: prodd?.waterSourceFunds ?? "N/A",
    },
    {
      key: "8",
      label: "Crops",
      children: prodd?.waterCrops ?? "N/A",
    },
    {
      key: "9",
      label: "Pipeline Type",
      children: prodd?.ptPipeline ?? "N/A",
    },
    {
      key: "10",
      label: "Brake Pressure Tanks",
      children: prodd?.waterBreakPressureTank ?? "N/A",
    },
    {
      key: "11",
      label: "Estimated Beneficiaries",
      children: prodd?.waterEstBeneficiaries ?? "N/A",
    },
    {
      key: "12",
      label: "Pathways",
      children: prodd?.waterPathways ?? "N/A",
    },
  ];
 
  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">Water Supply Infomation</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title=""
          column={1}
          colon={false}
          items={items1}
          layout="vertical"
        />
        <Descriptions
          title=""
          column={1}
          colon={false}
          items={items2}
          layout="vertical"
        />
        
      </div>
    </Drawer>
  );
}

export default WaterSupplyView;
